<template>
    <div>
        <div>
            <fieldset>
                <div class="row">
                    <legend>Shipping Information</legend>
                </div>
            </fieldset>
        </div>
        <div class="row">
            <div class="column small-12 medium-6">
                <div class="row">
                    <div class="columns small-4">
                        Ship To:
                    </div>
                    <div class="columns small-8">
                        {{sampleobject.name}}
                    </div>
                </div>
                <div class="row">
                    <div class="columns small-8 small-offset-4">
                        {{sampleobject.addressLine1}}
                    </div>
                </div>
                <div class="row">
                    <div class="columns small-8 small-offset-4">
                        {{sampleobject.addressLine2}}
                    </div>
                </div>
                <div class="row">
                    <div class="columns small-8 small-offset-4">
                        {{sampleobject.city}}, {{sampleobject.region}} {{sampleobject.postalCode}}
                    </div>
                </div>
    
            </div>
            <div class="column small-12 medium-6">
                <div class="row">
                    <div class="columns small-5">
                        Mobile Phone:
                    </div>
                    <div class="columns small-7">
                        {{sampleobject.phone}}
                    </div>
                </div>

                <div class="row">
                    <div class="columns small-5">
                        Mobile Phone:
                    </div>
                    <div class="columns small-7">
                        {{sampleobject.mobilePhone}}
                    </div>
                </div>
    
                <div class="row">
                    <div class="columns small-5">
                        Email:
                    </div>
                    <div class="columns small-7">
                        {{sampleobject.email}}
                    </div>
                </div>
    
            </div>
        </div>
    
    </div>
</template>
<script>
export default {
  props: ["sampleobject"]
};
</script>
